(function () {
    'use strict';

    let component = {
        transclude: true,
        templateUrl:
            'app/js/components/controls/billwerk-date-picker-component/billwerk-date-picker.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmBDP",
        bindings: {
            localDate: '=',
            ngRequired: '<',
            minDate: '<',
            maxDate: '<',
            showcleanbtn: '<',
            tooltipMode: '<',
            disabled: '<'
        }
    };

    iteroComponents.component('billwerkDatePicker', component);

    controller.$inject = ['$locale', 'PUtill', 'DatepickerUtils'];

    function controller($locale, PUtill, DatepickerUtils) {
        const ctrl = this;

        let localDatePrevValue;
        let internalModelPrevValue;

        ctrl.$onInit = function () {
            DatepickerUtils.setOptions(ctrl);
            internalModelPrevValue = ctrl.internalModel;
            localDatePrevValue = ctrl.localDate;
            ctrl.tooltipPlacement = ctrl.tooltipPlacement || 'top';
        };

        ctrl.$doCheck = function() {
            DatepickerUtils.turnMinAndMaxDateToBerlin(ctrl);
            ctrl.localDate = PUtill.convertToDateIfString(ctrl.localDate);
            
            // something set directly using the datepicker
            if (!PUtill.areDatesEqual(internalModelPrevValue, ctrl.internalModel)) {
                if (ctrl.internalModel) {
                    internalModelPrevValue = new Date(ctrl.internalModel);
                    let internalDateString = PUtill.toShortDateString(ctrl.internalModel);
                    let internalMidnight = DatepickerUtils.parseBerlinDate(internalDateString);
                    
                    ctrl.localDate = DatepickerUtils.backToBrowserTimezone(internalMidnight);
                    localDatePrevValue = new Date(ctrl.localDate);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone(localDatePrevValue);
                } else
                    internalModelPrevValue = localDatePrevValue = ctrl.localDate = null;
            }

            // something set outside
            if (!PUtill.areDatesEqual(localDatePrevValue, ctrl.localDate)) {
                if (ctrl.localDate) {
                    localDatePrevValue = new Date(ctrl.localDate);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone(localDatePrevValue);
                    ctrl.internalModel = DatepickerUtils.adjustToDst(ctrl.localDate);
                    internalModelPrevValue = new Date(ctrl.internalModel);
                } else
                    internalModelPrevValue = localDatePrevValue = ctrl.internalModel = null;
            }
        };

        DatepickerUtils.defineChangeEvent(ctrl);
        DatepickerUtils.defineOpen(ctrl);
        DatepickerUtils.init(ctrl);
    }
})();
